import { StatusOption } from '../../utils'

export enum MissionTypeEnum {
  STAFF = 'STAFF',
  OFFICE = 'OFFICE',
  EXTERNAL = 'EXTERNAL'
}

export const missionTypeEnumMapping: Record<MissionTypeEnum, StatusOption> = {
  [MissionTypeEnum.OFFICE]: {
    label: 'Bureau',
    variant: 'success'
  },
  [MissionTypeEnum.EXTERNAL]: {
    label: 'Externe',
    variant: 'purple'
  },
  [MissionTypeEnum.STAFF]: {
    label: 'AAT',
    variant: 'warning'
  }
}
